import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const FullLoader = () => (
  <div className="min-h-screen grid place-items-center bg-background">
    <Loader2 className="h-8 w-8 animate-spin text-brand" />
  </div>
);

export function ProtectedRoute({ children, role = "customer" }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <FullLoader />;
  if (!user) return <Navigate to={role === "admin" ? "/secure-admin/login" : "/login"} replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/secure-admin/login" replace />;
  if (role === "customer" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
